import ListRecentReviews from './ListRecentReviews';

export default ListRecentReviews;
